import React, { useState } from 'react';
import style from './tabs.module.scss';

const Tabs = ({ tabs }) => {
  const [activeIndex, setActiveIndex] = useState(0);
  if (!tabs || tabs.length === 0) return null;

  return (
    <div className={style.tabs}>
      <div className={style.tabbar} role="tablist">
        {tabs.map((tab, index) => (
          <button
            key={tab.id}
            type="button"
            role="tab"
            aria-selected={activeIndex === index}
            className={`${style.tab} ${
              activeIndex === index ? style.active : ''
            }`}
            onClick={() => setActiveIndex(index)}
          >
            {tab.label}
          </button>
        ))}
      </div>
      {tabs.map((tab, index) =>
        activeIndex === index ? (
          <div key={tab.id} className={style.panel} role="tabpanel">
            {tab.content}
          </div>
        ) : null
      )}
    </div>
  );
};

export default Tabs;
